import LifeAtPestel from "./LifeAtPestel/LifeAtPestel";
import OpenPositions from "./OpenPositions/OpenPositions";
import WhyJoinUs from "./WhyJoinUs/WhyJoinUs";
import WorkWithUS from "./WorkWithUS/WorkWithUS";
import SEO from "../../components/SEO";

export default function Careers({ currentLanguage = "en" }) {
  // SEO titles based on language
  const pageTitles = {
    en: "Careers",
    fr: "Carrières", // ✅ correct French title
  };

  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <>
      <SEO title={pageTitle} />
      <WorkWithUS currentLanguage={currentLanguage} />
      <WhyJoinUs currentLanguage={currentLanguage} />
      <OpenPositions currentLanguage={currentLanguage} />
      <LifeAtPestel currentLanguage={currentLanguage} />
    </>
  );
}
